import * as React from "react";
import CustomTitleField from "./Fields/CustomTitleField";

interface ContactWidgetSettingsProps {
  index: number;
}

const ContactWidgetSettings: React.FC<ContactWidgetSettingsProps> = ({ index }) => {
  return (
    <div className="playerCardWidgetOwner playerCardContact">
      <span>
        Whenever someone clicks on this widget, it will export the Player Card to a contact card that can be saved to
        their contacts.
      </span>
      <CustomTitleField index={index} />
    </div>
  );
};
export default ContactWidgetSettings;
